import React from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { ProcessingContainer } from './styles';
import { todayDate } from "../../../../../../../../utils/commonUtil";
import { confirmationProcessingDetailsState } from "../../../../selectors";

function ConfirmationProcessingDetails(props) {

  return (
    <ProcessingContainer className="flex">
      <div className="flex">
        <div>
          Transaction ID:
          <span>{props.successData && props.successData.transactionId}</span>
        </div>
        <div className="flex mt-10">
          <div>
            Entered Date:
            <span>{todayDate()}</span>
          </div>
        </div>
      </div>
    </ProcessingContainer>
  );
}

ConfirmationProcessingDetails.propTypes = {
  successData: PropTypes.object
}

const mapStateToProps = state => ({
  ...confirmationProcessingDetailsState(state.toJS())
});

export default connect(mapStateToProps, null)(ConfirmationProcessingDetails);
